import { useState } from "react";
import heic2any from "heic2any";

function ImageUploader({ setImageUrl }) {
  const [isConverting, setIsConverting] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const isHeic =
      file.type === "image/heic" ||
      file.type === "image/heif" ||
      /\.(heic|heif)$/i.test(file.name);

    if (!isHeic) {
      setImageUrl(URL.createObjectURL(file)); // State in App.js ändern
      return;
    }

    // HEIC/HEIF wird von den meisten Browsern (außer Safari) nicht
    // direkt in <img>/Canvas unterstützt -> in JPEG umwandeln.
    setIsConverting(true);
    try {
      const converted = await heic2any({
        blob: file,
        toType: "image/jpeg",
        quality: 0.9,
      });
      const jpegBlob = Array.isArray(converted) ? converted[0] : converted;
      setImageUrl(URL.createObjectURL(jpegBlob));
    } catch (err) {
      console.error("HEIC-Konvertierung fehlgeschlagen:", err);
      alert(
        "Dieses Bildformat (HEIC) konnte nicht verarbeitet werden. Bitte wähle ein JPEG- oder PNG-Bild.",
      );
    } finally {
      setIsConverting(false);
      e.target.value = "";
    }
  };

  return (
    <div style={{ position: "relative", width: "100%" }}>
      <input
        type="file"
        accept="image/*"
        onChange={handleFile}
        disabled={isConverting}
        id="file-upload"
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          opacity: 0,
          cursor: isConverting ? "default" : "pointer",
          zIndex: 2,
        }}
      />
      <label
        htmlFor="file-upload"
        style={{
          display: "block",
          padding: "0.875rem 1.5rem",
          fontSize: "clamp(0.9rem, 2.5vw, 1rem)",
          cursor: "pointer",
          backgroundColor: "#2c2c2e",
          color: "#ffffff",
          border: "2px solid #3c3c3e",
          borderRadius: "12px",
          fontWeight: "600",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.3)",
          transition: "all 0.2s ease",
          textAlign: "center",
          userSelect: "none",
          WebkitTapHighlightColor: "transparent",
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.backgroundColor = "#3c3c3e";
          e.currentTarget.style.borderColor = "#00ccff";
          e.currentTarget.style.transform = "translateY(-2px)";
          e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 204, 255, 0.3)";
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.backgroundColor = "#2c2c2e";
          e.currentTarget.style.borderColor = "#3c3c3e";
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.3)";
        }}
      >
        {isConverting ? "Bild wird hochgeladen..." : "Datei hochladen"}
      </label>
    </div>
  );
}

export default ImageUploader;
